<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <versionamento-bdgd-data-table />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import tourMixins from '@/mixins/tourMixins';
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    components: {
      VersionamentoBdgdDataTable: () => import('@/components/versionamentoBdgd/VersionamentoBdgdDataTable')
    },
    mixins: [pusherMixins, tourMixins],

    data() {
      return {};
    },

    mounted() {},

    methods: {}
  };
</script>
